import { Head, useForm, Link } from "@inertiajs/react";
import PlainLayout from "@/layouts/plain-layout";
import { session_path, new_password_path } from "@/routes";

function NewSession({ email, invitation_token: invitationToken }) {
  const { data, setData, post, processing } = useForm({
    email: email || "",
    password: "",
    invitation_token: invitationToken || ""
  });

  const submit = (e) => {
    e.preventDefault();
    post(session_path());
  };

  return (
    <>
      <Head title="Log ind" />

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-sm rounded-4 border-0">
              <div className="card-body p-4">
                <h1 className="h4 text-center fw-semibold mb-4">Log ind på Obsero Core</h1>

                <form className="vstack gap-3" onSubmit={submit}>
                  <div>
                    <label className="form-label">E-mail</label>
                    <input className="form-control rounded-3" type="email" value={data.email} onChange={(e) => setData("email", e.target.value)} required autoFocus />
                  </div>
                  <div>
                    <label className="form-label">Adgangskode</label>
                    <input className="form-control rounded-3" type="password" value={data.password} onChange={(e) => setData("password", e.target.value)} required />
                  </div>
                  <button className="btn btn-primary w-100 rounded-3 py-2 fw-semibold" disabled={processing}>Log ind</button>
                </form>

                <div className="text-center mt-3">
                  <Link href={new_password_path()} className="small text-decoration-none">Glemt adgangskode?</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

NewSession.layout = (page) => <PlainLayout>{page}</PlainLayout>;

export default NewSession;
